<!--<button mat-icon-button
(click)="toggleCloseStatus(true)"
[matMenuTriggerFor]="menu"
matBadgePosition="below|after"
matBadgeColor="warn"
matBadgeHidden="{{ unreadCount === 0 }}"
matBadge="{{unreadCount}}"
data-cy="notifications-toggle-button">
<i class="material-icons">notifications</i>
</button>
<mat-menu #menu="matMenu" (closed)="toggleCloseStatus(false)" data-cy="notifications-menu">

  <div class="action-container" (click)="$event.stopPropagation();" data-cy="notifications-action-container">
    <button mat-button color="primary" class="left-button" (click)="toggleMute()" data-cy="notifications-mute-toggle">
      <i class="material-icons" *ngIf="muted" matTooltip="Unmute" data-cy="notifications-muted-icon">volume_off</i>
      <i class="material-icons" *ngIf="!muted" matTooltip="Mute" data-cy="notifications-unmuted-icon">volume_up</i>
    </button>
    <button mat-button color="primary" class="right-button" (click)="clear()" data-cy="notifications-clear-button">clear</button>
  </div>
  <div class="main-container" (click)="$event.stopPropagation();" data-cy="notifications-container">
    <div class="notification-item" *ngFor="let notificationItem of notificationList; let i = index" [class.accent-item]="(i % 2) !== 0" data-cy="notifications-item">
      {{ notificationItem.notificationMessage }}
    </div>
  </div>

</mat-menu>-->


<div class="absolute-container mat-elevation-z2" data-cy="notifications-absolute-container">
  <div class="action-container" data-cy="notifications-actions">
    <button mat-button color="primary" class="left-button" (click)="toggleMute()" data-cy="notifications-mute-button">
      @if (notificationSettings.muted) {
        <i class="material-icons" matTooltip="Unmute" data-cy="notifications-muted-icon">volume_off</i>
      }
      @if (!notificationSettings.muted) {
        <i class="material-icons" matTooltip="Mute" data-cy="notifications-unmuted-icon">volume_up</i>
      }
    </button>
    <button mat-button color="primary" class="right-button" (click)="clear()" data-cy="notifications-clear-button">clear</button>
  </div>
  <div class="main-container" (click)="$event.stopPropagation();" data-cy="notifications-list-container">
    @for (notificationItem of notificationList; track notificationItem; let i = $index) {
      <div class="notification-item" (click)="markNotificationAsRead(notificationItem)" [class.accent-item]="(i % 2) !== 0" data-cy="notifications-list-item">
        {{ notificationItem.notificationMessage }}
      </div>
    }
  </div>
</div>
